export default "__VITE_ASSET__DaPgkhoo__"